import styled from 'styled-components';
import FeatherIcon from '../../util/FeatherIcon';
import Link from '../../util/Link';

export const LoyaltyComponent = styled.div`
    display: flex;
    cursor: pointer;

    &:hover {
        & > a svg,
        & > span svg {
            transform: rotate(${props => props.postIconActiveRotation});
        }
    }

    &.collapsible.open {
        & > span svg {
            transform: rotate(${props => props.postIconActiveRotation});
        }
    }

    a, span {
        display: flex;
        flex: 1;
        align-items: center;
    }

    p {
    margin: 0;
    padding: 0 5px;
    }

    ${({ styles }) => styles}
`;

export const StyledAccordionLabel = styled.span(({ styles }) => styles);
export const StyledLinkLabel = styled(Link)(({ styles }) => styles);

export const PostIcon = styled(FeatherIcon)(({ styles }) => styles);
export const PreIcon = styled(FeatherIcon)(({ styles }) => styles);